import { useNavigate } from "react-router-dom";
import { GraftonChatPanel } from "./grafton-chat/GraftonChatPanel";
import type { GraftonChatProps } from "./grafton-chat/types";

/** Wrapper that auto-injects router navigation into GraftonChatPanel */
export const GraftonChat = (props: Omit<GraftonChatProps, "onNavigate">) => {
  const navigate = useNavigate();
  return <GraftonChatPanel {...props} onNavigate={(route) => navigate(route)} />;
};

export type { GraftonChatProps } from "./grafton-chat/types";
